const SELECTOR_LESSON_DESCRIPTION = ".bm-lesson__description";

export function updateLessonDescription(newPlayerEl: HTMLElement): void {
  const description = document.querySelector(SELECTOR_LESSON_DESCRIPTION);
  if (!description) {
    return;
  }

  description.textContent =
    newPlayerEl.getAttribute("data-lesson-description") || "";
}
